import React from "react";

/**
 * Reusable Table Component
 *
 * props:
 * - columns: [{ header: "Name", accessor: "name", render?: (row) => JSX }]
 * - data: array
 * - onRowClick?: function
 */

const Table = ({ columns, data, onRowClick }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No data available
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
          <tr>
            {columns.map((col, index) => (
              <th key={index} className="px-4 py-3 text-left">
                {col.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-100">
          {data.map((row, rowIndex) => (
            <tr
              key={row.id || rowIndex}
              onClick={() => onRowClick && onRowClick(row)}
              className={`transition ${
                onRowClick ? "hover:bg-gray-50 cursor-pointer" : ""
              }`}
            >
              {columns.map((col, colIndex) => (
                <td key={colIndex} className="px-4 py-3">
                  {col.render
                    ? col.render(row)
                    : row[col.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;